module.exports = __webpack_public_path__ + "img/20.2-gallery.57b80a7b.jpg";